module.exports = __webpack_public_path__ + "img/SEO-suite-logo.32396602.png";